var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import chroma from "chroma-js";
import { Vector2i, Assert, E } from "js-vextensions";
import { BaseComponentPlus } from "react-vextensions";
import { GetMapObjectFinalPosition } from "Store/firebase/mapObjects/$mapObject";
import { DistanceUnit, ShapeType } from "Store/firebase/mapObjects/Components/@ShapeComp";
import * as THREE from "three";
import { MeshLine, MeshLineMaterial } from "three.meshline";
import { ToVector2, ToVector3 } from "Utils/General/Others";
import { BoxGeometry_PivotAtX, ShapeGeometry } from "Utils/UI/ThreeJS/General";
import { Observer } from "vwebapp-framework";
import { ToolRender_ExtraInfo } from "./Tools/Tool";
import { currentMapTool } from "./MapScene";
let MapObjectUI = class MapObjectUI extends BaseComponentPlus({}, {}) {
    static ValidateProps(props) {
        Assert(props.finalPos != null, "finalPos must be supplied to MapObjectUI.");
        Assert(props.finalPos instanceof Vector2i, "finalPos must be a Vector2i.");
    }
    /*shouldComponentUpdate(newProps: Props, newState) {
        // if generic prop changed occured, update
        if (ShallowChanged(newProps.Excluding("worldViewArea"), this.props.Excluding("worldViewArea")) || ShallowChanged(newState, this.state)) return true;
        // if zoom changed, update
        let zoomChanged = newProps.worldViewArea.width != this.props.worldViewArea.width || newProps.worldViewArea.height != this.props.worldViewArea.height;
        if (zoomChanged) return true;
        return false;
    }*/
    render() {
        let { obj, mapScene, finalPos } = this.props;
        finalPos = finalPos ?? GetMapObjectFinalPosition(obj);
        if (obj.shape == null)
            return null;
        const color_chroma = chroma(obj.shape.color ? `rgba(${obj.shape.color})` : `rgba(255,0,0,1)`);
        const color_noOpacity = new THREE.Color(color_chroma.alpha(1).css());
        const opacity = color_chroma.alpha();
        let mainGeometryUI;
        let mainMaterialUI = React.createElement("meshBasicMaterial", { color: color_noOpacity, transparent: opacity != 1, opacity: opacity != 1 ? opacity : 1 });
        //let mainMaterialUI = <meshStandardMaterial color={color_noOpacity} transparent={opacity != 1 ? true : false} opacity={opacity != 1 ? opacity : 1}/>;
        if (obj.shape.type == ShapeType.Path) {
            const meshLine = new MeshLine();
            var geometry = new THREE.Geometry();
            geometry.vertices = obj.shape.pathPoints.map(a => ToVector3(a));
            meshLine.setGeometry(geometry);
            var material = new MeshLineMaterial(E({ resolution: ToVector2(mapScene.ViewSize_Meters()), near: .1, far: 1000, color: color_noOpacity }, color_chroma.alpha() != 1 && { transparent: true, depthTest: false, opacity }, 
            //obj.shape.thicknessUnit == DistanceUnit.Meters && {sizeAttenuation: true, lineWidth: obj.shape.thickness},
            obj.shape.thicknessUnit == DistanceUnit.Meters &&
                { sizeAttenuation: true, lineWidth: (obj.shape.thickness * mapScene.MeterLengthInPixels()) / mapScene.ViewSize_Pixels().y }, obj.shape.thicknessUnit == DistanceUnit.Pixels &&
                { sizeAttenuation: false, lineWidth: obj.shape.thickness / mapScene.ViewSize_Pixels().y }));
            // for this to work, you have to add the CustomGeometry.tsx (and such) descriptors to the ElementDescriptorContainer.descriptors object
            mainGeometryUI = React.createElement("customGeometry", { geometry: meshLine.geometry });
            mainMaterialUI = React.createElement("customMaterial", { material: material });
            //return <mesh position={ToVector3(obj.position)} rotation={new THREE.Euler()} geometry={meshLine.geometry} material={material}/>;
        }
        else if (obj.shape.type == ShapeType.Rectangle) {
            mainGeometryUI = React.createElement(BoxGeometry_PivotAtX, { width: obj.shape.rect.width, height: obj.shape.rect.height, depth: 1, pivotPoint_rel: new Vector2i(0, 0) });
        }
        else if (obj.shape.type == ShapeType.Region) {
            mainGeometryUI = React.createElement(ShapeGeometry, { shapes: [LineArrayToShape(obj.shape.pathPoints)] });
        }
        const tool = currentMapTool;
        const toolRender_extraInfo = new ToolRender_ExtraInfo();
        const toolRender_result = tool && tool.RenderForObject(obj, toolRender_extraInfo);
        return (React.createElement("group", null,
            !toolRender_extraInfo.cancelNormalRender &&
                React.createElement("mesh", { position: ToVector3(finalPos), rotation: new THREE.Euler() },
                    mainGeometryUI,
                    mainMaterialUI),
            toolRender_result));
    }
};
MapObjectUI = __decorate([
    Observer
], MapObjectUI);
export { MapObjectUI };
export function LineArrayToShape(points, closePolygon = false) {
    const shape = new THREE.Shape();
    shape.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) {
        shape.lineTo(points[i].x, points[i].y);
    }
    if (closePolygon) {
        shape.lineTo(points[0].x, points[0].y);
    }
    // shape is invalid with less than 3 points, so just add stubs till we're to 3
    for (var count = points.length; count < 3; count++) {
        shape.lineTo(points[0].x + (count * .01), points[0].y + (count * .01));
    }
    return shape;
}
